import React from "react";
import { Link } from "react-router-dom";
import {
  ShieldCheck, Target, Zap, TrendingUp, ArrowUpRight, Globe, Mail, MapPin,
} from "lucide-react";
import { C, Reveal } from "./shared";

const PILLARS = [
  { icon: ShieldCheck, t: "Verified Skills", s: "Build Trust", c: C.green },
  { icon: Target, t: "Better Matches", s: "Better Outcomes", c: "#22D3EE" },
  { icon: Zap, t: "Faster Hiring", s: "Save Time", c: C.green },
  { icon: TrendingUp, t: "Stronger Placements", s: "Stronger Futures", c: "#22D3EE" },
];

export default function FinalCTABand() {
  return (
    <section className="text-white relative overflow-hidden" style={{ background: C.navyDeep }}>
      <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full opacity-20 blur-3xl anim-orb"
        style={{ background: `radial-gradient(circle, ${C.green} 0%, transparent 70%)` }} aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-10">
        <Reveal>
          <h2 className="font-display font-black text-3xl md:text-5xl leading-[1.05]">
            LET&apos;S BUILD<br/>
            <span style={{ color: C.green }}>VERIFIED CAREERS</span> TOGETHER
          </h2>
          <p className="text-white/70 mt-5 max-w-md">
            Join SkillConnect and connect students, working professionals, universities, companies, and institutes on one powerful employability platform.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link to="/signup?role=student" data-testid="band-cta-student"
              className="px-5 py-3 rounded-lg font-semibold text-white inline-flex items-center gap-2 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:scale-105"
              style={{ background: C.green }}>
              Join as Student <ArrowUpRight size={14} />
            </Link>
            <Link to="/signup?role=company" data-testid="band-cta-company"
              className="px-5 py-3 rounded-lg font-semibold inline-flex items-center gap-2 border border-white/30 transition-all duration-300 hover:bg-white/10 hover:-translate-y-1 hover:scale-105">
              Hire on SkillConnect <ArrowUpRight size={14} />
            </Link>
          </div>
        </Reveal>

        <div className="grid grid-cols-2 gap-3 sm:gap-5">
          {PILLARS.map((p, i) => (
            <Reveal key={p.t} delay={(i % 4) + 1}>
              <div className="group rounded-xl p-3 sm:p-5 bg-white/5 border border-white/10 cursor-default transition-all duration-500 hover:bg-white/10 hover:border-white/30 hover:-translate-y-1 hover:shadow-xl" data-testid={`pillar-${i}`}>
                <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg grid place-items-center transition-all duration-300 group-hover:scale-110 group-hover:rotate-6"
                  style={{ background: `${p.c}25`, color: p.c }}>
                  <p.icon size={18} />
                </div>
                <div className="mt-2.5 font-bold text-[13px] sm:text-sm leading-tight">{p.t}</div>
                <div className="text-[11px] sm:text-xs text-white/60 mt-0.5 leading-snug">{p.s}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-sm text-white/80">
          <div className="flex flex-wrap gap-6">
            <span className="inline-flex items-center gap-2 transition-colors hover:text-white"><Globe size={14} style={{ color: C.green }} /> www.skillconnect.com</span>
            <span className="inline-flex items-center gap-2 transition-colors hover:text-white"><Mail size={14} style={{ color: C.green }} /> info@skillconnect.com</span>
            <span className="inline-flex items-center gap-2 transition-colors hover:text-white"><MapPin size={14} style={{ color: C.green }} /> India</span>
          </div>
          <div className="font-display font-extrabold text-xs tracking-widest uppercase" style={{ color: C.green }}>
            One Ecosystem · Endless Possibilities
          </div>
        </div>
      </div>
    </section>
  );
}
